export default __webpack_public_path__ + "static/media/doodle_string.73c222e6.svg";